import { useState } from "react";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await login(email, pw); } catch (er) { setError(errMsg(er)); }
    setBusy(false);
  };
  return (
    <div className="min-h-screen grid lg:grid-cols-[1.1fr_1fr]">
      <div className="hidden lg:flex flex-col justify-between bg-slate-950 text-white p-12 grain relative overflow-hidden">
        <div className="text-2xl font-extrabold tracking-[0.25em]">MŌNA</div>
        <div className="max-w-lg">
          <div className="text-emerald-400 text-xs font-bold uppercase tracking-[0.2em] mb-4">Operations Control</div>
          <h1 className="text-4xl xl:text-5xl font-bold leading-tight tracking-tight">Setiap barang bergerak, tercatat nilainya, penanggung jawabnya, dan jejaknya.</h1>
          <div className="mt-10 grid grid-cols-3 gap-px bg-white/10 rounded-lg overflow-hidden text-xs">
            {["Pembelian", "Penerimaan", "Review", "Transfer", "Konsumsi", "Opname"].map((s, i) => (
              <div key={s} className="bg-slate-950 p-3"><span className="num text-emerald-400">0{i + 1}</span><div className="mt-1 font-semibold">{s}</div></div>
            ))}
          </div>
        </div>
        <div className="text-xs text-slate-500">Gudang → Outlet · Stok berbasis ledger · Audit trail lengkap</div>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm fade-up" data-testid="login-form">
          <div className="lg:hidden text-2xl font-extrabold tracking-[0.25em] mb-8">MŌNA</div>
          <h2 className="text-2xl font-bold tracking-tight">Masuk</h2>
          <p className="text-sm text-slate-500 mt-1 mb-6">Gunakan akun yang diberikan oleh Owner.</p>
          <label className="block text-xs font-semibold text-slate-600 mb-1">Email</label>
          <input className="inp h-10 mb-4" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email-input" />
          <label className="block text-xs font-semibold text-slate-600 mb-1">Kata sandi</label>
          <input className="inp h-10" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required data-testid="login-password-input" />
          {error && <div role="alert" className="mt-3 text-sm text-rose-600" data-testid="login-error">{error}</div>}
          <button disabled={busy} className="mt-6 w-full h-10 rounded-md bg-slate-900 text-white font-semibold hover:bg-emerald-700 transition-colors flex items-center justify-center gap-2" data-testid="login-submit-button">
            {busy && <Loader2 size={16} className="animate-spin" />} Masuk
          </button>
        </form>
      </div>
    </div>
  );
}
